import React, {useState} from "react";
import MainButton from "../../commons/mainButton";
import Loader from "../../commons/loader";
import {GLOBAL_BORDER_RADIUS} from "../../../costants";
import MyNormalText from "../../commons/myNormalText";
import DatePicker from "react-datepicker";
import {httpsCallable} from "firebase/functions";
import {functions} from "../../../firebase";
import {fromMomentDateToYYYYMMDD, toMomentDate, toMomentDateFromYYYYMMDD} from "../../../global/dates";
import * as XLSX from "xlsx";

function Extractions({rentUser, premiumPalette}) {
    const primaryColor = premiumPalette.primaryColor;
    const secondaryColor = premiumPalette.secondaryColor;

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [bookings, setBookings] = useState(null);
    const [usersLoading, setUsersLoading] = useState(false);
    const [users, setUsers] = useState(null);

    function handleCalculateExtractions(groupByOrder = false) {
        if (!fromDate || !toDate) {
            return;
        }

        setLoading(true);
        const rentSuperUserAdminMaintenanceClientOrdersView = httpsCallable(functions, "rentSuperUserAdminMaintenanceClientOrdersView");
        const request = {
            rentId: rentUser.rentId,
            dateFrom: fromDate,
            dateTo: toDate,
            groupByOrder,
        };
        rentSuperUserAdminMaintenanceClientOrdersView(request)
            .then((response) => {
                setBookings(response.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }

    function handleExportToExcel() {
        if (!bookings || bookings.length === 0) {
            return;
        }

        const excelData = bookings.map((item) => {
            // Se groupByOrder è true, items è un array; altrimenti, i dati sono per singolo item
            if (item.items) {
                const itemsString = item.items
                    .map((i) => `${i.name} (ID: ${i.id}, Categoria: ${i.category}, Taglia: ${i.size}, Totale: ${i.total})`)
                    .join("; ");
                return {
                    Cliente_Email: item.clienteEmail,
                    Cliente_Nome: item.clienteNome,
                    Cliente_UID: item.clienteUid || "-",
                    Data_Ordine: item.dataOrdine,
                    Dal: item.dal,
                    Al: item.al,
                    Nome_Noleggio: item.nomeNoleggio,
                    Payment_ID_Stripe: item.paymentIdStripe,
                    Slot: item.slot,
                    Articoli: itemsString,
                    Nazionalita: item.nazionalita,
                    Order_ID: item.orderId,
                    Status: item.status,
                    Totale_Ordine: item.total,
                    Data_Inserimento: item.timeStampInsertDate,
                    Tipo: item.type,
                };
            } else {
                return {
                    Cliente_Email: item.clienteEmail,
                    Cliente_Nome: item.clienteNome,
                    Cliente_UID: item.clienteUid || "-",
                    Data_Ordine: item.dataOrdine,
                    Dal: item.dal,
                    Al: item.al,
                    Nome_Noleggio: item.nomeNoleggio,
                    Payment_ID_Stripe: item.paymentIdStripe,
                    Slot: item.slot,
                    Nazionalita: item.nazionalita,
                    Order_ID: item.orderId,
                    Status: item.status,
                    Totale_Ordine: item.total,
                    Data_Inserimento: item.timeStampInsertDate,
                    Tipo: item.type,
                    Item_Nome: item.itemName,
                    Item_ID: item.itemId,
                    Item_Categoria: item.itemCategory,
                    Item_Taglia: item.itemSize,
                    Item_Totale: item.itemTotal,
                };
            }
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Ordini");

        // Determina le larghezze delle colonne in base al formato dei dati
        const isGroupedByOrder = bookings[0]?.items; // Controlla se il primo elemento ha la proprietà items
        worksheet["!cols"] = isGroupedByOrder
            ? [
                {wch: 25}, // Cliente_Email
                {wch: 20}, // Cliente_Nome
                {wch: 25}, // Cliente_UID
                {wch: 15}, // Data_Ordine
                {wch: 15}, // Dal
                {wch: 15}, // Al
                {wch: 20}, // Nome_Noleggio
                {wch: 25}, // Payment_ID_Stripe
                {wch: 15}, // Slot
                {wch: 50}, // Articoli (più largo per la stringa concatenata)
                {wch: 15}, // Nazionalita
                {wch: 15}, // Order_ID
                {wch: 15}, // Status
                {wch: 15}, // Totale_Ordine
                {wch: 15}, // Data_Inserimento
                {wch: 10}, // Tipo
            ]
            : [
                {wch: 25}, // Cliente_Email
                {wch: 20}, // Cliente_Nome
                {wch: 25}, // Cliente_UID
                {wch: 15}, // Data_Ordine
                {wch: 15}, // Dal
                {wch: 15}, // Al
                {wch: 20}, // Nome_Noleggio
                {wch: 25}, // Payment_ID_Stripe
                {wch: 15}, // Slot
                {wch: 15}, // Nazionalita
                {wch: 15}, // Order_ID
                {wch: 15}, // Status
                {wch: 15}, // Totale_Ordine
                {wch: 15}, // Data_Inserimento
                {wch: 10}, // Tipo
                {wch: 20}, // Item_Nome
                {wch: 15}, // Item_ID
                {wch: 15}, // Item_Categoria
                {wch: 15}, // Item_Taglia
                {wch: 15}, // Item_Totale
            ];

        XLSX.writeFile(workbook, `Ordini_from__${fromDate}__to__${toDate}.xlsx`);
    }

    function handleCalculateUsers() {
        setUsersLoading(true);
        const rentSuperUserAdminMaintenanceClientUsersView = httpsCallable(functions, "rentSuperUserAdminMaintenanceClientUsersView");
        const request = {rentId: rentUser.rentId};
        rentSuperUserAdminMaintenanceClientUsersView(request)
            .then((response) => {
                setUsers(response.data);
                setUsersLoading(false);
            })
            .catch(() => setUsersLoading(false));
    }

    function handleExportUsersToExcel() {
        if (!users || users.length === 0) return;

        const excelData = users.map((user) => ({
            UID: user.uid,
            Email: user.email,
            Provider: user.provider,
            Data_Creazione: user.creationTime,
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

        worksheet["!cols"] = [{wch: 30}, {wch: 25}, {wch: 15}, {wch: 25}];

        XLSX.writeFile(workbook, `Utenti.xlsx`);
    }

    return (
        <div style={pageStyle.container}>
            <div>
                {loading ? <Loader absoluteFullPage={true}/> : <></>}
                <div style={{...pageStyle.section, backgroundColor: primaryColor}}>
                    <MyNormalText text={"Ordini dal - al"} bold={true} fontSize={18}/>
                    <div style={{display: "flex", gap: 10}}>
                        <DatePicker
                            selected={fromDate ? toMomentDateFromYYYYMMDD(fromDate).toDate() : null}
                            onChange={(date) => setFromDate(fromMomentDateToYYYYMMDD(toMomentDate(date)))}
                            showMonthYearDropdown={false}
                            className={"custom-input"}
                            dateFormat={"dd/MM/yyyy"}
                            locale={"it"}
                            placeholderText={"Data inizio"}
                        />
                        <DatePicker
                            selected={toDate ? toMomentDateFromYYYYMMDD(toDate).toDate() : null}
                            onChange={(date) => setToDate(fromMomentDateToYYYYMMDD(toMomentDate(date)))}
                            showMonthYearDropdown={false}
                            className={"custom-input"}
                            dateFormat={"dd/MM/yyyy"}
                            locale={"it"}
                            placeholderText={"Data Fine"}
                        />
                    </div>
                </div>
                <div style={{display: "flex", gap: 10, marginTop: 10}}>
                    <div style={{flex: 3}}>
                        <MainButton
                            text={"Calcola Ordini (per Item)"}
                            action={() => handleCalculateExtractions(false)}
                            backgroundColor={secondaryColor}
                        />
                    </div>
                    <div style={{flex: 3}}>
                        <MainButton
                            text={"Calcola Ordini (per Ordine)"}
                            action={() => handleCalculateExtractions(true)}
                            backgroundColor={secondaryColor}
                        />
                    </div>
                    <div style={{flex: 1}}>
                        <MainButton
                            text={"Excel"}
                            action={handleExportToExcel}
                            secondaryImage={require('../../../imgs/actions/excel.png')}
                            secondaryImageHeight={20}
                            secondaryImageWidth={20}
                            backgroundColor={secondaryColor}
                            disabled={!bookings || bookings.length === 0}
                        />
                    </div>
                </div>
            </div>
            <div>
                {usersLoading ? <Loader absoluteFullPage={true}/> : <></>}
                <div style={{...pageStyle.section, backgroundColor: primaryColor}}>
                    <MyNormalText text={"Utenti"} bold={true} fontSize={18}/>
                    <MyNormalText text={"Vengono estratti tutti gli utenti"}/>
                </div>
                <div style={{display: "flex", gap: 10, marginTop: 10}}>
                    <div style={{flex: 5}}>
                        <MainButton
                            text={"Calcola Utenti"}
                            action={handleCalculateUsers}
                            backgroundColor={secondaryColor}
                        />
                    </div>
                    <div style={{flex: 1}}>
                        <MainButton
                            text={"Excel"}
                            action={handleExportUsersToExcel}
                            secondaryImage={require('../../../imgs/actions/excel.png')}
                            secondaryImageHeight={20}
                            secondaryImageWidth={20}
                            backgroundColor={secondaryColor}
                            disabled={!users || users.length === 0}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

const pageStyle = {
    container: {
        display: "flex",
        flexDirection: "column",
        gap: 50,
    },
    section: {
        display: "flex",
        flexDirection: "column",
        padding: 10,
        gap: 5,
        borderRadius: GLOBAL_BORDER_RADIUS,
    },
};

export default Extractions;
